import Vue from 'vue'
import App from './App.vue'
import {i18n} from './plugins/i18n'
import {router} from './router'
import store from './store'
import jQuery from 'jquery'
import VueXlsx from 'vue-js-xlsx'
import VueMask from 'v-mask'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/tr-TR'
import VueApexCharts from 'vue-apexcharts'
import VueGeolocation from 'vue-browser-geolocation';
import Tawk from 'vue-tawk';
import Vidle from 'v-idle'


Vue.use(Tawk, {tawkSrc: 'https://embed.tawk.to/5dee224043be710e1d21368b/default'})

global.jQuery = jQuery;
global.$ = jQuery;

Vue.use(VueGeolocation);
Vue.use(VueXlsx);
Vue.use(ElementUI, {locale});
Vue.use(VueMask);
Vue.use(Vidle);
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
import vrcode from '@ispa.io/vrcode'
Vue.component('vrcode', vrcode);
import 'bootstrap'
import 'jquery/dist/jquery.min'

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  VueMask,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js